module.exports = __webpack_public_path__ + "img/project-19.ae773aa3.png";